<div *ngIf="init" [attr.telemetry]="Section-AccountDetails-ProjectAccounting" (click)="$event.stopPropagation()" fxLayout="row" style="outline:none;">
    <account-detail-card [account]="detail" fxFlex="auto" [index]="id" type="P">
    </account-detail-card>
</div>